/**
 * Nothing the dashboard asks the server for is served from a cache.
 *
 * Every screen here is a view of the database at the moment it is opened -
 * orders, balances, statuses - and a list the browser kept from earlier is a
 * list that is wrong without saying so. The server answers no-store; this is
 * the same rule from the browser's side, so it holds even for a response that
 * arrives without the header.
 *
 * fetch  every request goes out with cache "no-store". No header is added, so
 *        a cross-origin request from the dev server needs no extra preflight.
 * axios  every GET carries a one-off `_nc` parameter, which no cache anywhere -
 *        the browser, Cloudflare, a proxy - can hold a stored answer for.
 *        Writes are left exactly as they were.
 */
export default function installNoCache(win, http) {
  if (win && typeof win.fetch === "function" && !win.fetch.noCacheInstalled) {
    const native = win.fetch.bind(win);
    const noStoreFetch = (input, init = {}) => native(input, { ...init, cache: "no-store" });

    noStoreFetch.noCacheInstalled = true;
    // eslint-disable-next-line no-param-reassign
    win.fetch = noStoreFetch;
  }

  if (http && http.interceptors && !http.noCacheInstalled) {
    http.interceptors.request.use((config) => {
      const method = String(config.method || "get").toLowerCase();

      if (method !== "get") return config;

      return { ...config, params: { ...(config.params || {}), _nc: Date.now() } };
    });

    // eslint-disable-next-line no-param-reassign
    http.noCacheInstalled = true;
  }
}
